import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// CORE COMPONENTS
import Form from 'core/form/Form';

// PARTS
import Card from 'parts/card/Card';
import { formatDateTime } from 'functions';

// STYLES
import styles from './comments.module.scss';

// VARIABLES
const ITEM_CONSTRUCTOR = () => ({
  daily_sales_comment_id: '',
  comment: '',
  item_add_as_task: false
});

// FORM
const CommentsForm = () => {
  // CONTEXT
  const {
    values: { aryCurrentComment }
  } = useFormikContext() || {};

  return (
    <Form.Body>
      {aryCurrentComment?.length
        ? aryCurrentComment.map(
            ({ date_updated, daily_sales_comment_id, comment, posted_by }, index) =>
              daily_sales_comment_id !== '' && (
                <div key={`${daily_sales_comment_id} - ${index}`} className="w-100  p-4 d-flex flex-column ">
                  <div className="w-100  d-flex flex-row justify-content-between">
                    <span className={styles.span}>{posted_by}</span>
                    <span className={styles.spanUser}>{formatDateTime(date_updated)}</span>
                  </div>
                  <h5 className="p-2">{comment}</h5>
                  <hr />
                </div>
              )
          )
        : null}
      <Form.Table name="aryComment" itemLabel="Comment" itemConstructor={ITEM_CONSTRUCTOR} hideHeader={true}>
        {() => [
          <Form.Textarea name="comment" label="Comment" maxLength={100} colWidth={18} required />,
          <Form.YesNo name="item_add_as_task" text="Add as Task" type="checkbox" numeric={false} colWidth={6} />
        ]}
      </Form.Table>
    </Form.Body>
  );
};

// EXPORT
export default function Comments(props) {
  return <Card title="Comments" body={<CommentsForm {...props} />} />;
}
